import React from 'react';
import { useNavigate } from 'react-router-dom';
import Sidebar from '../../components/Sidebar';
import { BackButton } from '../../components/ui/Button';
import { OptionCard, TipBox, PageHeader } from '../../components/ui';

const writingOptions = [
  {
    id: 'idea-to-post',
    icon: 'mdi:lightbulb',
    iconColor: '#F59E0B',
    iconBgColor: '#FEF3C7',
    title: 'Start from Ideas',
    subtitle: 'Idea to Post',
    description: 'Enter your ideas or topics, AI helps you brainstorm and generate complete posts',
    path: '/templates/idea-to-post'
  },
  {
    id: 'random-post',
    icon: 'mdi:dice-multiple',
    iconColor: '#EC4899',
    iconBgColor: '#FCE7F3',
    title: 'Random Inspiration',
    subtitle: 'Random Post',
    description: 'No ideas? Let AI randomly generate interesting post topics for you',
    path: '/templates/random-post'
  },
  {
    id: 'ai-tool-recommendation',
    icon: 'mdi:robot',
    iconColor: '#3B82F6',
    iconBgColor: '#DBEAFE',
    title: 'AI Tool Posts',
    subtitle: 'Tool Recommendation',
    description: 'Generate AI tool introduction and recommendation posts',
    path: '/templates/ai-tool-recommendation',
    comingSoon: true
  }
];

function AIWritingHub() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-[var(--bg-primary)] text-[var(--text-primary)]">
      <div className="flex h-screen">
        <Sidebar activePage="home" />

        <div className="flex-1 overflow-y-auto bg-gray-50">
          {/* Back Button */}
          <BackButton
            onClick={() => navigate('/home')}
            className="fixed top-6 left-[280px] z-[100]"
          >
            Back to Home
          </BackButton>

          <div className="max-w-[900px] mx-auto px-8 py-16">
            {/* Header */}
            <PageHeader
              badge="AI Writing"
              badgeIcon="mdi:pencil"
              title="Choose Your Starting Point"
              subtitle="Start from different inspiration sources, AI helps you generate quality text posts"
            />

            {/* Options Grid */}
            <div className="grid grid-cols-[repeat(auto-fit,minmax(280px,1fr))] gap-4">
              {writingOptions.map((option) => (
                <OptionCard
                  key={option.id}
                  icon={option.icon}
                  iconColor={option.iconColor}
                  iconBgColor={option.iconBgColor}
                  title={option.title}
                  subtitle={option.subtitle}
                  description={option.description}
                  comingSoon={option.comingSoon}
                  onClick={() => navigate(option.path)}
                />
              ))}
            </div>

            {/* Quick Tips */}
            <TipBox className="mt-8">
              Generated posts can be published directly to Threads or saved as drafts for later editing.
              For carousel image posts, use the "Card Generator" feature.
            </TipBox>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AIWritingHub;
